import React from 'react';
import { MapPin, Mail, Phone, Facebook, Linkedin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const policies = [
    { name: 'Privacy Policy', href: '/policies/privacy' },
    { name: 'Data Protection Policy', href: '/policies/data-protection' },
    { name: 'Cookies Policy', href: '/policies/cookies' },
    { name: 'Corporate Social Responsibility', href: '/policies/csr' },
    { name: 'Anti-Slavery Policy', href: '/policies/anti-slavery' },
    { name: 'Anti-Bribery Policy', href: '/policies/anti-bribery' }
  ];

  return (
    <footer className="bg-slate-950 text-white relative overflow-hidden">
      {/* Gradient Top Border */}
      <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-blue-600 via-cyan-600 to-blue-600"></div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12 text-center md:text-left justify-items-center">
          {/* Location & Socials */}
          <div>
            <h3 className="text-xl font-bold mb-4 flex items-center justify-center md:justify-start gap-2 text-white">
              <MapPin className="w-5 h-5 text-blue-400" />
              Location
            </h3>
            <p className="text-slate-400 leading-relaxed mb-5">
              126 High Street West,<br />
              Glossop SK13 8HJ
            </p>
            <div className="flex items-center justify-center md:justify-start gap-3" data-testid="footer-socials">
              <a
                href="https://www.facebook.com/profile.php?id=61569344494621"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center w-10 h-10 bg-slate-800 hover:bg-blue-600 rounded-lg transition-colors group"
                aria-label="Follow us on Facebook"
                data-testid="social-facebook"
              >
                <Facebook className="w-5 h-5 text-slate-400 group-hover:text-white transition-colors" />
              </a>
              <a
                href="https://www.linkedin.com/company/binary-consultancy-ltd"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center w-10 h-10 bg-slate-800 hover:bg-blue-700 rounded-lg transition-colors group"
                aria-label="Follow us on LinkedIn"
                data-testid="social-linkedin"
              >
                <Linkedin className="w-5 h-5 text-slate-400 group-hover:text-white transition-colors" />
              </a>
            </div>
          </div>

          {/* Policies */}
          <div>
            <h3 className="text-xl font-bold mb-4 text-white">Policies</h3>
            <ul className="space-y-2">
              {policies.map((policy) => (
                <li key={policy.href}>
                  <a
                    href={policy.href}
                    className="text-slate-400 hover:text-blue-400 transition-colors text-sm"
                  >
                    {policy.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-xl font-bold mb-4 text-white">Contact</h3>
            <div className="space-y-3">
              <a
                href="mailto:helpme@bincon.co.uk"
                className="flex items-center gap-2 text-slate-400 hover:text-blue-400 transition-colors"
              >
                <Mail className="w-4 h-4" />
                helpme@bincon.co.uk
              </a>
              <a
                href="mailto:sales@bincon.co.uk"
                className="flex items-center gap-2 text-slate-400 hover:text-blue-400 transition-colors"
              >
                <Mail className="w-4 h-4" />
                sales@bincon.co.uk
              </a>
              <a
                href="tel:+441457855590"
                className="flex items-center gap-2 text-slate-400 hover:text-blue-400 transition-colors"
              >
                <Phone className="w-4 h-4" />
                +44 1457 855590
              </a>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-slate-800 pt-8 text-center">
          <p className="text-slate-500 text-sm">
            © Copyright {currentYear} Binary Consultancy Limited - All Rights Reserved
          </p>
          <p className="text-slate-600 text-xs mt-2">
            Website developed by <a href="https://bincon.co.uk" target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:text-blue-400 transition-colors">Binary Consultancy</a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;